<template>
  <iColumn gap="small" width="fill">
    <iRow
      v-for="(season, idx) in placeholderSeasons"
      :key="idx"
      gap="small"
      vertical-align="middle"
      width="fill"
      :style-overrides="{
        paddingTop: 'small',
        paddingBottom: 'small',
        paddingLeft: 'small',
        paddingRight: 'small',
        borderRadius: 'standard',
        backgroundColor: '#f4f5f7',
      }"
    >
      <iColumn gap="extraSmall" width="fill">
        <iText font-weight="strong">
          Season {{ season.seasonNumber }}
        </iText>
        <iText variant="subtle" font-size="small">
          {{ season.numEpisodes }} episodes
        </iText>
      </iColumn>
    </iRow>
  </iColumn>
</template>

<script>
// Same reasoning as ShowEpisodes.vue — SmartFeedV2 + smart-feed-engine
// live outside the editor directory tree.
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";

export default {
  name: "ShowSeasons",
  mixins: [
    DynamicElementMixin,
  ],
  elementPanelSettings: {
    displayName: "Show Seasons",
    displayIcon: "feed",
    elementGroup: "show",
    elementType: "element",
  },
  options: [
    new LayoutWidth({
      "default": "fill",
      "hover": "fill",
    }, true),
    new EmptyStateText({
      "default": "There are no seasons available yet.",
    }),
  ],
  computed: {
    placeholderSeasons() {
      return [
        { seasonNumber: 1, numEpisodes: 10 },
        { seasonNumber: 2, numEpisodes: 8 },
        { seasonNumber: 3, numEpisodes: 12 },
      ];
    },
  },
};
</script>
